import React from 'react';
import { useTranslation } from 'react-i18next';
import FlowCard from './FlowCard';
import ActionButtons from './ActionButtons';

const APPEAL_WINDOW_MS = 10 * 60 * 1000;

/**
 * disputed_no_show: the accused party (actorKey 'accused') gets a 10-minute
 * window to Admit or Dispute. Everyone else sees a "waiting for response" note.
 * If the window lapses, resolve_expired_no_shows() (pg_cron) confirms the no-show.
 */
export default function NoShowCard({ row = {}, actions = [], dispatch, busy, roleColorVar }) {
  const { t } = useTranslation('common');
  const canRespond = actions.some((a) => a.action === 'admit_no_show' || a.action === 'dispute_no_show');
  const deadline = row.updated_at ? new Date(new Date(row.updated_at).getTime() + APPEAL_WINDOW_MS) : null;

  return (
    <FlowCard step={t('flow.step_dispute')} title={t('flow.no_show_title')} roleColorVar={roleColorVar}>
      <p>{canRespond ? t('flow.no_show_accused_body') : t('flow.no_show_reporter_body')}</p>
      {deadline && (
        <p className="flow-deadline">{t('flow.no_show_deadline', { time: deadline.toLocaleTimeString() })}</p>
      )}
      {canRespond && (
        <div className="flow-card-actions">
          <ActionButtons actions={actions} dispatch={dispatch} busy={busy} only={['admit_no_show', 'dispute_no_show']} />
        </div>
      )}
    </FlowCard>
  );
}
